import { PortableTextReactComponents } from "next-sanity";

export const components: Partial<PortableTextReactComponents> = {
  block: {
    h1: ({ children }) => (
      <h1 className="text-4xl sm:text-5xl xl:text-6xl 2xl:text-7xl font-outfit font-semibold text-[#E6EBF3] leading-[1.1] tracking-tight text-center mb-6">
        {children}
      </h1>
    ),
    h2: ({ children }) => (
      <h2 className="text-3xl sm:text-4xl xl:text-5xl 2xl:text-6xl font-outfit font-medium text-[#E6EBF3] leading-[1.15] tracking-tight text-center mb-5">
        {children}
      </h2>
    ),
    h3: ({ children }) => (
      <h3 className="text-2xl sm:text-3xl xl:text-4xl font-outfit font-medium text-[#E6EBF3] leading-[1.2] tracking-tight text-center mb-4">
        {children}
      </h3>
    ),
    h4: ({ children }) => (
      <h4 className="text-xl sm:text-2xl xl:text-3xl font-outfit font-medium text-[#E6EBF3] leading-[1.2] tracking-tight text-center mb-4">
        {children}
      </h4>
    ),
    h5: ({ children }) => (
      <h5 className="text-lg sm:text-xl xl:text-2xl font-outfit font-medium text-[#E6EBF3] leading-[1.25] tracking-tight text-center mb-3">
        {children}
      </h5>
    ),
    h6: ({ children }) => (
      <h6 className="text-base sm:text-lg xl:text-xl font-outfit font-medium text-[#E6EBF3] leading-[1.25] tracking-tight text-center mb-3">
        {children}
      </h6>
    ),
    normal: ({ children }) => (
      <p className="text-[#E6EBF3] text-base sm:text-lg xl:text-xl leading-relaxed md:max-w-[500px] lg:max-w-2xl text-center mx-auto mb-4 font-light">
        {children}
      </p>
    ),
  },
  marks: {
    strong: ({ children }) => (
      <strong className="font-semibold text-[#E6EBF3]">{children}</strong>
    ),
    highlight: ({ children }) => (
      <span className="text-success-500 font-semibold">{children}</span>
    ),
    em: ({ children }) => <em className="italic">{children}</em>,
    link: ({ children, value }) => (
      <a
        href={value?.href}
        className="text-[#0B0B0B] underline underline-offset-4 decoration-2 hover:decoration-[#404040] transition-colors"
        target={value?.blank ? "_blank" : undefined}
        rel={value?.blank ? "noopener noreferrer" : undefined}
      >
        {children}
      </a>
    ),
  },
};
